__turbopack_context__.v({
  "className": "dm_sans_feac2522-module__FK_poW__className",
  "variable": "dm_sans_feac2522-module__FK_poW__variable",
});
